
import React, { useState, useEffect } from "react";
import PopupForm from "../../../Components/PopupForm";
import { useTranslation } from "react-i18next";
import geofenceObject, {
  objectMerge
} from "../../../Errors/Geofences/Geofence";
import { toast } from "react-toastify";
import Cookies from "universal-cookie";
import { useNavigate } from "react-router-dom";
import geofenceAPI from "../../../Network/Geofence";
import RenderFooter from "./RenderFooter";
import RenderContent from "./RenderContent";
const label = { inputProps: { "aria-label": "Switch demo" } };

const cookies = new Cookies();


export default function UpdateNameFormContainer(props) {
  const [t] = useTranslation("common");
  const [loading, setLoading] = useState(false);
  const [geofence, setGeofence] = useState(geofenceObject);
  const navigate = useNavigate();

  const submit = async () => {
    try {
      let checkErrorObject = {
        ...geofence
      }
      let hasError = false
      let readyToSendObject = {}
      if (geofence?.name?.value && geofence?.name?.value?.trim()?.length > 0) {
        let name = geofence?.name?.value?.trim()
        readyToSendObject["name"] = name?.replace(/\\|\/|\'/g, "");
      }
      else {
        hasError = true
        checkErrorObject['name']['error'] = true
        checkErrorObject['name']['message'] = [t('GLOBAL.mandatory_field')]
      }
      
      if (hasError) {
        setGeofence({
          ...checkErrorObject
        })
        return
      }

      confirmSubmit(readyToSendObject)
      
    } catch (error) {

      setLoading(false);
      toast.error(error.message);
    }

  };
  const confirmSubmit = async (readyToSendObject) => {
    if (
      cookies.get("active_session") &&
      cookies.get("active_session") == "yes"
    ) {
      try {

        let params = {
          username: cookies.get("user_name"),
          user_id: cookies.get("user_id"),
          account_name: cookies.get("account_name"),
          account_id: cookies.get("account_id"),
          sid: cookies.get("sid"),
          baseurl: cookies.get("baseUrl"),
          id: cookies.get("id"),
        };

        let result = null;
        if (props?.object && props?.object?.id) {
          readyToSendObject["id"] = props?.object?.id;

          result = await geofenceAPI.editGeofenceName({
            data: readyToSendObject,
            params: params,
            id: props?.object?.id,
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          });
        } else {

          toast.error(t("NETWORK_MESSAGES.unknownError"))
          return
        }

        if (result?.status && result?.data?.status) {

          setLoading(false);

          toast.success(t("NETWORK_MESSAGES.infoAddedSuccessfully"));
          clearForm();
          props?.loadData();
          props?.setOpenForm(false);
        } else {

          setLoading(false);

          if (result?.data?.data?.message?.text == "unauthorized to complete") {
            navigate("/redirect");
          }

          else {

            toast.error(result?.data?.data?.message?.text ? result?.data?.data?.message?.text : result?.data?.data?.message)
          }
        }
        setLoading(false);
      } catch (error) {

        setLoading(false);
        toast.error(error.message);
      }
    } else {

      // navigate('/redirect')
    }
  }

  const clearForm = () => {
    setGeofence(geofenceObject)
  };
  useEffect(() => {
    if (!props?.object) {
      clearForm();

    } else {
      const mergedObject = objectMerge(props?.object)
      setGeofence(mergedObject)
    }
  }, [props?.openForm, props?.object]);


  return (
    <PopupForm
      open={props?.openForm}
      setOpen={props?.setOpenForm}
      title={
        props?.object?.id
          ? t("GEOFENCES.update_title")
          : t("GEOFENCES.add_title")
      }
      isFullScreen={false}
      customeHeight={'300px'}
      customWidth={'500px'}
      content={
        <RenderContent
          object={geofence}
          setObject={(value) => {
            setGeofence(value)
          }}
          open={props?.openForm}
          setOpen={props?.setOpenForm}
          isFullScreen={false}
        />
      }
      footer={
        <RenderFooter
          open={props?.openForm}
          setOpen={props?.setOpenForm}
          submit={submit}
          clearForm={clearForm}
        />
      }
    />
  );
}
